import { LabelProps, Label } from './Label';
export function LabelDisplay1(props: LabelProps) {
    return (
        <Label
            color="text-dark-red"
            variant="text-mobile-display-1"
            {...props}
        />
    );
}
